import { render, staticRenderFns } from "./xpItem.vue?vue&type=template&id=35944e15&scoped=true"
import script from "./xpItem.vue?vue&type=script&lang=js"
export * from "./xpItem.vue?vue&type=script&lang=js"
import style0 from "./xpItem.vue?vue&type=style&index=0&id=35944e15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35944e15",
  null
  
)

export default component.exports